import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useLang, catLabel } from "../lib/i18n";
import { LangToggle } from "../components/LangToggle";
import { StatusBadge } from "../components/StatusBadge";
import { ClientBottomNav } from "../components/ClientBottomNav";
import { ArrowLeft, ChevronRight, Inbox } from "lucide-react";

export default function ClientOrders() {
  const { t, lang } = useLang();
  const nav = useNavigate();
  const [orders, setOrders] = useState(null);

  useEffect(() => { api.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => setOrders([])); }, []);

  return (
    <div className="relative mx-auto min-h-screen max-w-md bg-slate-50 pb-24">
      <header className="sticky top-0 z-30 flex items-center justify-between border-b border-slate-200 bg-white px-4 py-3">
        <button onClick={() => nav("/area-clienti")} className="text-slate-500"><ArrowLeft /></button>
        <span className="font-display text-lg font-bold text-slate-900">{t("my_orders")}</span>
        <LangToggle />
      </header>

      <div className="space-y-3 p-4">
        {orders === null && <p className="text-center text-sm text-slate-400">{t("loading")}</p>}
        {orders?.length === 0 && (
          <div className="mt-16 flex flex-col items-center gap-3 text-slate-400">
            <Inbox className="h-12 w-12" /><p className="text-sm font-semibold">{t("no_orders")}</p>
            <button data-testid="empty-new-request" onClick={() => nav("/area-clienti/richiedi")} className="rounded-xl bg-blue-600 px-4 py-2 text-sm font-bold text-white">{t("request_intervention")}</button>
          </div>
        )}
        {orders?.map((o) => (
          <button key={o.id} data-testid={`order-card-${o.id}`} onClick={() => nav(`/ordine/${o.id}`)}
            className="card-hover flex w-full items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4 text-left">
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="font-mono text-xs font-bold text-blue-600">{o.code}</span>
                {o.is_demo && <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-bold text-slate-500">DEMO</span>}
              </div>
              <p className="mt-0.5 text-sm font-bold text-slate-900">{o.problem}</p>
              <p className="text-xs text-slate-500">{catLabel(o.category, lang)}</p>
              <div className="mt-2"><StatusBadge status={o.status} /></div>
            </div>
            <ChevronRight className="h-5 w-5 text-slate-300" />
          </button>
        ))}
      </div>
      <ClientBottomNav />
    </div>
  );
}
